Ext.define('SA.view.menu.LocationCaption', {
    alias: 'widget.menu-location-caption',
    extend: 'Ext.Component',

    baseCls: 'sa-report-grid-menu-caption',
    emptyText: '\u00a0',

    beforeMenuShow() {
        this.refresh();
    },

    refresh() {
        var location = this.location,
            text = this.emptyText;

        if (location === 'name') {
            text = 'Data Variable';
        }
        else {
            location = SA.data.LocationsCache.get(location, this.refresh, this);

            if (location) {
                text = Ext.util.Format.locationRenderer(location);
            }
        }

        this.update(text);
    }
});